import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getTournament = (id) => {
  return axios.get(`${getBackendUrl()}/tournament/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const join = (id, participantId) => {
  return axios.post(
    `${getBackendUrl()}/tournament/${id}/join/${participantId}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const leave = (id, participantId) => {
  return axios.post(
    `${getBackendUrl()}/tournament/${id}/leave/${participantId}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const kick = (id, participantId) => {
  return axios.post(
    `${getBackendUrl()}/tournament/${id}/kick/${participantId}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const setStatus = (id, status) => {
  return axios.post(
    `${getBackendUrl()}/tournament/setstatus`,
    { id: id, status: status },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const getEventTournaments = (id) => {
  return axios.get(`${getBackendUrl()}/event/${id}/tournaments`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getUserTournaments = (id) => {
  return axios.get(`${getBackendUrl()}/tournaments/user/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addTournament = (id, tournmanet) => {
  return axios.put(`${getBackendUrl()}/event/${id}/tournament`, tournmanet, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const editTournament = (tournmanet) => {
  return axios.post(`${getBackendUrl()}/tournament`, tournmanet, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const generateMatches = (id) => {
  return axios.post(
    `${getBackendUrl()}/tournament/${id}/generatematches`,
    {},
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const getMatches = (id) => {
  return axios.get(`${getBackendUrl()}/tournament/${id}/matches`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const closeMatch = (id, match) => {
  return axios.post(`${getBackendUrl()}/tournament/${id}/match/result`, match, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const editMatchResult = (id, match) => {
  return axios.post(`${getBackendUrl()}/tournament/${id}/match/edit-result`, match, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const startMatch = (id, match) => {
  return axios.post(`${getBackendUrl()}/tournament/${id}/match/start`, match, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const setWinner = (id, participantId) => {
  return axios.post(
    `${getBackendUrl()}/tournament/${id}/winner/${participantId}`,
    {},
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const getWinner = (id) => {
  return axios.get(`${getBackendUrl()}/tournament/${id}/winner`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const remove = (id) => {
  return axios.delete(`${getBackendUrl()}/tournament/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getTeamsJoinedByCaptain = (id, captain) => {
  return axios.get(
    `${getBackendUrl()}/tournament/${id}/teamsjoinedbycaptain/${captain}`,
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const selectGroupStageWinner = (id, winner) => {
  return axios.post(
    `${getBackendUrl()}/tournament/${id}/selectgroupwinner`,
    winner,
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const reGenerateTeams = (id) => {
  return axios.post(`${getBackendUrl()}/tournament/${id}/regenerateteams`, {}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const reset = (id) => {
  return axios.post(`${getBackendUrl()}/tournament/${id}/reset`, {}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};